import React from "react";
import { Box, Link as MuiLink, IconButton } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export default function Footer() {
    const location = useLocation();

    const isImpressumPage = location.pathname === "/impressum";

    return (
        <Box
            component="footer"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            px={4}
            height={80}
            bgcolor="#e0e0e0"
        >
            {isImpressumPage ? (
                <MuiLink component={Link} to="/" underline="hover" color="inherit">
                    Home
                </MuiLink>
            ) : (
                <MuiLink component={Link} to="/impressum" underline="hover" color="inherit">
                    Impressum
                </MuiLink>
            )}

            <Box>
                <IconButton
                    component="a"
                    href="https://www.instagram.com/friedrichsstartup"
                    target="_blank"
                    rel="noopener noreferrer"
                    color="inherit"
                >
                    <InstagramIcon />
                </IconButton>
                <IconButton
                    component="a"
                    href="https://www.linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    color="inherit"
                >
                    <LinkedInIcon />
                </IconButton>
            </Box>
        </Box>
    );
}
